import React from 'react';
import { useLocation } from 'react-router-dom';
import Footer from './Footer';

const FooterWrapper = () => {
  const location = useLocation();
  const hostname = window.location.hostname;
  const isRentalSubdomain = hostname.startsWith('rent.');
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isGalleryPage = location.pathname.startsWith('/gallery');

  // Check if we're on the main one-pager (collections with about section)
  const isOnePagerRoute = location.pathname === '/' ||
                          location.pathname.startsWith('/about') ||
                          location.pathname.match(/^\/(jnn-drc|absence-of-promised-safety|des-nachtmahrs-schmetterlinge|alluvial)$/);

  // Don't render footer for rental subdomain, admin routes, gallery, or CV page
  // One-pager routes show footer (handled by Footer scroll detection)
  if (isRentalSubdomain || isAdminRoute || isGalleryPage || location.pathname === '/about/cv') {
    return null;
  }

  return <Footer />;
};

export default FooterWrapper;
